import React, { useContext, useEffect } from 'react';
import TeacketContext from 'src/context/TeacketContext';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import CondensedTable from 'src/components/layout/CondensedTable';
import { getTickets } from 'src/api/teacket';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
//import PropTypes from 'prop-types';

const TicketListControl = () => {
  const { executeAsyncProcess } = useAsyncProcesses();
  const navigate = useNavigate();
  const { ticketList, setTicketList } = useContext(TeacketContext);

  useEffect(() => {
    if (!ticketList) loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      title: 'Ticket ID',
      key: 'id',
      render: (record) => (
        <Button
          type='link'
          style={{ maxWidth: '400px', overflow: 'hidden', textOverflow: 'ellipsis' }}
          onClick={async () => {
            navigate(`/teacket/tickets/${record.id}`);
          }}
        >
          <strong>{record.id}</strong>
        </Button>
      ),
    },
    {
      title: 'Title',
      key: 'title',
      width: 320,
      render: (record) => <div style={{ maxWidth: '300px', wordWrap: 'normal', overflow: 'hidden', textOverflow: 'ellipsis' }}>{record.title}</div>,
    },

    {
      title: 'Category',
      key: 'category',
      align: 'center',
      render: (record) => <div style={{ maxWidth: '300px', wordWrap: 'normal', overflow: 'hidden', textOverflow: 'ellipsis' }}>{record.category}</div>,
    },
    {
      title: 'Subcategory',
      key: 'sub_category',
      align: 'center',
      render: (record) => <div style={{ maxWidth: '300px', wordWrap: 'normal', overflow: 'hidden', textOverflow: 'ellipsis' }}>{record.sub_category}</div>,
    },
    {
      title: 'Priority',
      key: 'priority',
      align: 'center',
      render: (record) => <div style={{ maxWidth: '300px', wordWrap: 'normal', overflow: 'hidden', textOverflow: 'ellipsis' }}>{record.priority}</div>,
    },
    {
      title: 'Status',
      key: 'status',
      align: 'center',
      render: (record) => <div style={{ maxWidth: '300px', wordWrap: 'normal', overflow: 'hidden', textOverflow: 'ellipsis' }}>{record.status}</div>,
    },
    {
      title: 'Created',
      key: 'created_at',
      align: 'center',
      render: (record) => (
        <>
          {dayjs(record.created_at).fromNow()}
          <br />
          <span className='font-thin text-xs'>at {dayjs(record.created_at).format('LLL')}</span>
        </>
      ),
    },
  ];

  const loadData = async () => {
    await executeAsyncProcess(async () => {
      try {
        const tickets = await getTickets();
        setTicketList(tickets);
      } catch (error) {
        console.error(error);
      }
    });
  };

  return (
    <>
      <CondensedTable columns={columns} dataSource={ticketList} rowKey={'id'} />
    </>
  );
};

TicketListControl.propTypes = {};

export default TicketListControl;
